
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'typeProduct'})
export class TypeProductPipe implements PipeTransform {

  transform(value: string): string {

    switch (value) {
      case 'A':
        return 'AVULSO'
      case 'P':
        return 'PACOTE'
    }
  }
}
